// Shared helpers for the tournament "Juegos" (skill challenges) feature.

/** Format a numeric value trimming trailing zeros (e.g. 12.500 -> "12.5", 30 -> "30"). */
export function formatGameValue(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return String(value ?? "");
  // Up to 3 decimals, then strip trailing zeros and a dangling dot.
  return n
    .toFixed(3)
    .replace(/\.?0+$/, "");
}

/** Human label for the ranking direction. */
export function directionLabel(higherIsBetter) {
  return higherIsBetter ? "Mayor gana" : "Menor gana";
}

/** Medal emoji for the top 3, empty otherwise. */
export function rankMedal(rank) {
  if (rank === 1) return "🥇";
  if (rank === 2) return "🥈";
  if (rank === 3) return "🥉";
  return "";
}
